module.exports = __webpack_public_path__ + "static/media/praxisraeume.f6230296.jpg";